<template>
  <PageMain
    ref="main"
    :tableData="tableData"
    :tablePage="page"
    :loading="loading"
    @reload="reload"
  >
    <PageHeader
      ref="header"
      slot="header"
      @query="getData"
      @reset="resetPage"
      :hxShipmentJdCode="hxShipmentJdCode"
      :disabled="disabled"
    />
    <template #toolbar_btn>
      <SortFieldsPopover
        v-model="sortFields"
        funcListName="hxJdShipmentOrderDetailList"
        style="margin-right: 0.8em;"
        @change="reload"
      />
    </template>
    <pagination
      size="small"
      align="right"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </PageMain>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable],
  components: { PageHeader, PageMain, SortFieldsPopover },
  props: {
    hxShipmentJdCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { usePage: true, sortFields: [] }
  },
  methods: {
    async getData(form) {
      if (!this.hxShipmentJdCode) return
      this.loading = true
      const res = await this.$api
        .ecomHxShipmentJdOrderDetailListApi({
          hxShipmentJdCode: this.hxShipmentJdCode,
          ...this.page,
          ...form,
          sortFields: this.sortFields,
        })
        .catch(() => false)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
  },
}
</script>
